export default function genererCritereRechercheMouvementStock() {
  return {
    societeId: null,
    tiersId: null,
  };
}
